import { CloudFunctionRates } from '@pretto/website/src/lib/apiRates/formatApiRates/types/cloudFunctionRates.types'
import { SimulatorType } from '@pretto/website/src/templates/blocs/components/simulatorRow/SimulatorRow.types'

import { useCapacity } from './useCapacity'
import { usePurchase } from './usePurchase'
import { useRenegotiation } from './useRenegotiation'

type SimulatorData = {
  trackButtonClick: (location: string) => void
}

const HOOK = {
  [SimulatorType.CAPACITY]: useCapacity,
  [SimulatorType.PURCHASE]: usePurchase,
  [SimulatorType.RENEGOTIATION]: useRenegotiation,
}

export const useSimulator = (
  type: SimulatorType,
  data: SimulatorData,
  marketRatesProfileLatest: CloudFunctionRates[]
) => {
  return HOOK[type](data, marketRatesProfileLatest)
}
